import { render } from "./AddressCard.vue?vue&type=template&id=174b2e70&scoped=true"
import script from "./AddressCard.vue?vue&type=script&lang=js"
export * from "./AddressCard.vue?vue&type=script&lang=js"

import "./AddressCard.vue?vue&type=style&index=0&id=174b2e70&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174b2e70"]])

export default __exports__